<!--
================================================
Un composant incitant les utilisateurs à démmarer leurs expérience

Url d'accès : http://localhost:8080/fr/cronocloud-inc/timeTracking

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="GettingStartedComp" v-show="displayGettingStarted" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
    <!--        {{'Hello ! :) I am ' + $options.name}}-->

    <div class="columns">
      <div class="column  ">


        <div class="gettingStarted">


                  <img
                       class=" is-block is-pulled-right mr-4 mb-4 welcomeIllustration"
                       src="../../assets/img/illustrations/Welcome-amico.svg"
                       alt="illustration"
                       height="140px"
                       width="140px" />

          <!-- J'ai mi le loader en pause suite à la limitation de l'afficahge du composant qui à présent est chargé que si l'user est considéré comme non onboardé @voir pour éventuellement réactivé --->
          <!--            <div class="compLoader" v-if="isLoading">-->
          <!--              <spinner-loader-comp></spinner-loader-comp>-->
          <!--              <p class="loadingMsg">{{ $t('chargement') }}</p>-->
          <!--            </div>-->
          <!--            <div v-else  class="contentWhenLoaded">-->
          <div class="contentWhenLoaded">
            <div class="header">
              <h2 class="title "><span v-html="$t('BienvenueStranger',{'firstname':firstname })"></span> 👋
                {{ $t('realiserCesTachesPourBienDemmarrer') }}</h2>

              <div class="columns is-mobile">
                <div class="column is-narrow">
                  <span class="percent">{{ stepsProgress }}%</span>

                </div>
                <div class="column">
                  <progress class="progress" v-bind:value="stepsProgress" max="100"></progress>

                </div>
              </div>


            </div>


            <!--STEP NON TERMINÉS NON IGNORÉS-->
            <div v-for="(step,name,index) in stepsData" v-bind:key="'unCompleted_'+name">
              <getting-started-step-comp v-if="!step.isDone && !step.isIgnored" :step="step" :name="name"
                                         :index="index"></getting-started-step-comp>
            </div>

            <!--STEP NON TERMINÉS IGNORÉS-->
            <div v-for="(step,name,index) in stepsData" v-bind:key="'ignored_'+name">
              <getting-started-step-comp v-if="!step.isDone && step.isIgnored" :step="step" :name="name"
                                         :index="index"></getting-started-step-comp>
            </div>

            <!--STEP TERMINÉS-->
            <div v-for="(step,name,index) in stepsData" v-bind:key="'completed_'+name">
              <getting-started-step-comp v-if="step.isDone" :step="step" :name="name"
                                         :index="index"></getting-started-step-comp>
            </div>
          </div>

        </div>

      </div>
    </div>


  </div>

</template>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar";
@import "../../assets/css/bulmaResponsiveDep.scss";

#GettingStartedComp {
  //////////////////////
  // light UI

  .gettingStarted {
    border-radius: 3px;
    border: solid 1px #ccc;
    //background-color: rgb(250, 250, 250);
    box-shadow: 0px 3px 5px 1px rgba(0, 1, 0, 0.2);
    margin: 0 auto 1.5rem auto;

    //.compLoader {
    //  margin: 2rem auto;
    //  color:#666;
    //}
    .header {
      padding: 1.7rem 2.4rem;
      //background: $superLightGreen;
      background: #f0f3f4;
      border-radius: 4px 4px 0 0;
      color: $brandThird;
      @include touch {
        padding: 1rem 2rem;
      }

      .title {
        text-align: left;
        color: $brandThird;
        font-weight: normal;
        font-size: 1.1rem;
        margin: 0 auto 0.8rem;

        & b {
          font-weight: bold;
        }

        @include touch {
          font-size: 1rem;
          line-height: 1.4rem;
        }
      }

      .progress {
        margin-top: 0.4rem;
        border: solid 1px #eee;
      }

      .percent {
        font-weight: bold;
        color:$brandFourth;
      }

      progress::-webkit-progress-bar {
        background-color: #ddd;
      }
      progress::-webkit-progress-value { background: $brandFourth; }


    }

    .card {
    }

  }


  /////////////////////////////////////////
  // DARK THEME ///////////////////////////.
  &.darkMode {
    .gettingStarted {
      border-color: transparent !important;

      box-shadow: 0px 2px 5px 1px $darkBg2;

      .header {
        background-color: $darkBg3;
        //color: $darkLightBlue;
        .title {
          color: $darkTxt;
        }

        .progress {
          border-color: transparent !important;
          background-color: $darkBg $darkLightBlue !important;
        }

        .percent {
          color: $darkLightBlue;
        }

        progress::-webkit-progress-bar {
          background-color: darken($darkBg3, 3%);
        }
        progress::-webkit-progress-value { background: $darkLightBlue; }

      }


    }

  }

}
</style>


<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "../../mixins/SentryMixin.js";
import SpinnerLoaderComp from "./../SpinnerLoaderComp.vue";
import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "../../mixins/InterceptorMixin.js";
import _ from "lodash";
import GettingStartedStepComp from "@/components/GettingStarted/GettingStartedStepComp";
import TrackingMixin from "@/mixins/TrackingMixin";

// import vClickOutside from 'v-click-outside'

export default {
  name: 'GettingStartedComp',
  components: {GettingStartedStepComp, SpinnerLoaderComp},
  //utile dans vue dev tool
  mixins: [
    GlobalErrorNotification,
    SentryMixin,
    InterceptorMixin,
    TrackingMixin
  ],


  props: {
    // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
    userType: String, // firstUser | collaborator
  },
  data: function () {
    return {
      locale: this.$route.params.locale,

      // =================================================================
      displayGettingStarted: false, // Bool |indique si le getting started doit être affiché
      nextStep2Complete: null, //string | La clé du nom du prochain step  (dans this.stepsData) à afficher comme "isUnfold"

      steps: {


        firstUser: {
          stepFirstUserJoin: {
            title: ' 🎉 ' + this.$t("creerMonCompte"), // String | le titre du step
            estimatedDuration: 1, // String | la durée estimée pour compléter le step
            isDone: true, // Bool | la complétion du step
            isIgnored: false, // Bool | si le step est ignoré
            isUnfold: false, // Bool | si le step est affiché ouvert

            content: {
              text: this.$t('SuperAprésentLancezVous'),  // String | le texte du step
              knowMoreLink: null, // String | url du lien 'en savoir plus"
              c2a: {
                text: null,  // String | text du bouton call to action
                route: null,  // String | nom de la route vers lequel pointe le bouton
                link: null, // String | si route null, lien vers lequel pointe le bouton @todo à implémenter
              }
            },


          },
          stepFirstUserValidEmail: {
            title: '📬 ' + this.$t("validerMonEmail"),
            estimatedDuration: 1,
            isDone: false,
            isIgnored: false,
            isUnfold: false,

            content: {
              text: this.$t('validezVotreAdresseEmailPourPouvoirUtiliserLesFonctionsAvanceesDeCronocloud'),
              knowMoreLink: null,
              c2a: {text: null, route: null, link: null,}
            },


          },
          stepFirstUserInvit: {
            title: '🧑‍🤝‍🧑 ' + this.$t("inviterMonEquipe"),
            estimatedDuration: 2,
            isDone: false,
            isIgnored: false,
            isUnfold: false,

            content: {
              text: this.$t('InviterMesCollaborateursPourSuivreLeursTempsPassésSurDesProjets'),
              knowMoreLink: null,
              c2a: {text: this.$t("inviterMonEquipe"), route: 'teamUsers', link: null,}
            },


          },
          stepFirstUserProject: {
            title: '🗂️ ' + this.$t("organiserMesProjets"),
            estimatedDuration: 5,
            isDone: false,
            isIgnored: false,
            isUnfold: false,

            content: {
              text: this.$t('structurezVotreSuiviDeTempsPourConnaitreLeTempsPasséSurChaqueProjetEtClient'),
              knowMoreLink: null,//"cronocloud.com",
              c2a: {text: this.$t("organiserMesProjets"), route: 'projects', link: null,}
            },


          },
          stepFirstUserReport: {
            title: '📊' + this.$t("consulterMesRapports"),
            estimatedDuration: 5,
            isDone: false,
            isIgnored: false,
            isUnfold: false,

            content: {
              text: this.$t('DecouvrezQuellesSontLesTachesEtProjetsSurLesquelsVousPassezLePlusDeTemps'),
              knowMoreLink: null,
              c2a: {text: null, route: null, link: null,}

            },


          },
        },
        ///////////////////////////////////////
        collaborator: {
          stepCollabJoin: {
            title: '🎉 ' + this.$t("rejoindreCronocloud"),
            estimatedDuration: 1,
            isDone: true,
            isIgnored: false,
            isUnfold: false,
            content: {
              text: this.$t('SuperAprésentLancezVous'),
              knowMoreLink: null,
              c2a: {text: null, route: null, link: null,}
            },
          },
          stepCollabValidEmail: {
            title: '📬 ' + this.$t("validerMonEmail"),
            estimatedDuration: 1,
            isDone: false,
            isIgnored: false,
            isUnfold: false,
            content: {
              text: this.$t('validezVotreAdresseEmailPourPouvoirUtiliserLesFonctionsAvanceesDeCronocloud'),
              knowMoreLink: null,
              c2a: {
                text: null,
                route: null,
                link: null,

              }

            },
          },
          stepCollabInstallPwa: {
            title: '📲 ' + this.$t("installerLApplicationWeb"),
            estimatedDuration: 1,
            isDone: false,
            isIgnored: false,
            isUnfold: false,

            content: {
              text: this.$t('CronocloudEstUnePwa'),
              knowMoreLink: null, //'https://cronocloud.com',
              c2a: {text: null, route: null, link: null,}
            },

          },
          stepCollabFirstTask: {
            title: '⏱ ' + this.$t("creerMonPremierPointage"),
            estimatedDuration: 1,
            isDone: false,
            isIgnored: false,
            isUnfold: false,

            content: {
              text: this.$t('creezVotrePremiereTache'),
              knowMoreLink: null,
              c2a: {text: null, route: null, link: null,}
            },


          },

        }
      },

      stepsData: null, // Object | Les données à utilisé selon le type d'utilisateur (une sous clé de this.steps)
      stepsProgress: 0, // Int | pourcentage de complétion

      isLoading: false, // Bool | indique si le composant est en train de charger des données

      completion: {
        /* Object | l'état de complétion du getting started (récupérée depuis l'api)
        isVerified: false,
        hasInvited: false,
        hasCreatedProject: false,
        hasViewedReport: false,
        hasInstalledPwa: false,
        hasCreatedTaskTr: false,
      */
      }


    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      firstname: state => state.user.firstname,
      themeToDisplay: state => state.app.themeToDisplay

    }),


  },
  watch: {
    // à chaque fois que la prop computed change, cette fonction s'exécutera
    // stepsData: function () {
    //   this.defineNextStep()
    // }
  },


  methods: {

    /*
     Définit le prochain step à comlpléter. (Le 1er step dans la liste qui est incomplet et non igonré)

     Permet notamment lorsque des steps sons complétés ou ignorés de marquer le prochain step comme 'isUnfold' afin de le promouvoir auprès de l'utilisateur
    */
    defineNextStep: function () {

      let self = this
      _.forEach(this.stepsData, function (step, key) {
        if (!step.isIgnored && !step.isDone) {
          self.nextStep2Complete = key;
          return false // on stoppe le foreach lodash dès que l'on tombe sur le premier step non terminés et non ignoré
        }
      })

      if (this.nextStep2Complete != null) {
        this.stepsData[this.nextStep2Complete].isUnfold = true;
      }

    },

    /*
      Calcule le pourcentage des steps terminés
    */
    calculProgress() {

      let stepsCount = 0;
      let stepsCompletedCount = 0;
      _.forEach(this.stepsData, function (data, key) {
        stepsCount++
        if (data.isDone) {
          stepsCompletedCount++
        }
      })
      this.stepsProgress = Math.round((stepsCompletedCount / stepsCount) * 100);
      // console.debug("il y a "+stepsCompletedCount + " terminés / "+ stepsCount + ' steps | '+ this.stepsProgress)
    },

    /*
      Active/Désactive la propriété "isUnfold" dans "stepsData" pour le step passé en paramètre
      @param step | un objet step du for
      @param index | index du for
    */
    toggleIsUnfold(step, index) {

      if (step.isUnfold) {
        this.stepsData[index].isUnfold = false

      } else {
        // on replie tous les steps au préalable...
        _.forEach(this.stepsData, function (data, key) {
          data.isUnfold = false
        })
        // ... avant de déplier le step voulu
        this.stepsData[index].isUnfold = true
      }


    },

    /*
      Active/Désactive la propriété "isIgnored" dans "stepsData" pour le step passé en paramètre
      @param step | un objet step de la boucle for
      @param index | index du for
     */
    toggleIsIgnored(step, index) {

      step.isIgnored ? this.stepsData[index].isIgnored = false : this.stepsData[index].isIgnored = true
      this.stepsData[index].isUnfold = false

      this.defineNextStep() // si un step est ignoré on remet à jour le prochain step

      this.saveIgnoredSteps()
      this.updateIgnoredSteps()

      this.$mixpanel.track("Getting started step ignored", {"step": index});
      this.ga4GlobalEventTrack('Getting started step ignored' , {bar:'bar'})


    },

    /*
      Sauvegarde l'état des steps ignorés dans un cookie
     */
    saveIgnoredSteps() {

      let cookieContent = []


      _.forEach(this.stepsData, function (step, key) {
        if (step.isIgnored) {
          cookieContent.push(key)
        }
      })


      this.$cookie.set(
          'ignoredGettingStarted',
          JSON.stringify(cookieContent),
          {
            expires: 365,
          }
      );

    },

    /*
     Détermine les données à afficher dans le getting started selon le type d'utilisateur passé en prop
     (Les ROLE_OWNER / USER ont des steps d'onboarding différents)
     */
    defineUserTypeDatas() {
      if (this.userType == 'firstUser') {
        this.stepsData = this.steps.firstUser;

      } else {
        this.stepsData = this.steps.collaborator;
      }
    },


    /**
     * Récupère les informations getting Started pour l'utilisateur via l'api
     * Sert à afficher des steps comme complétés en fonction des actions déjà réalisées
     **/
    getGettingStartedInfos() {

      let self = this;
      this.isLoading = true;

      self.$http.get(
          `organizations/${self.$auth.getOrganization()}/users/${self.$auth.getUserSlug()}/gettingStarted`,
          {
            params: {},
            headers: {Authorization: self.$auth.header()}
          }
      ).then(function (response) {
        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

        // Si tous les steps sont complets ou l'user déjà 'onboardé' alors on affiche pas le gettingstarted
        response.data.allStepsCompleted || response.data.userIsConsideredOnboarded ? self.displayGettingStarted = false : self.displayGettingStarted = true;
        self.completion = response.data
        self.updateCompletion()
        self.updateIgnoredSteps()
        self.calculProgress()
        self.defineNextStep()

      })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {

              let errorCode = "0048"
              self.showGlobalErrorNotif(self, errorCode)
              self.$mixpanel.track('global error displayed', {
                "id": errorCode,
                "detail": "error fetching gettingStarted Infos"
              })
              self.$gtag.exception({
                'description': 'error ' + errorCode + ' | error fetching gettingStarted Infos',
                'fatal': false
              })
              self.$sentry.captureMessage(`Error ${errorCode} > error fetching gettingStarted Infos : ${error}`, 'error')

            }
          })
          .then(() => {
            // toujours exécuté
            self.isLoading = false;

          })

    },
    /**
     * Met à jour this.stepsData en fonction des infos récupérées via l'api
     * Sert à afficher mettre à jour .isDone en fonction de l'état de complétion d'un step
     **/
    updateCompletion() {

      if (this.userType == 'collaborator') {
        if (this.completion.isVerified) {
          this.stepsData.stepCollabValidEmail.isDone = true;
        }
        if (this.completion.hasInstalledPwa) {
          this.stepsData.stepCollabInstallPwa.isDone = true;
        }
        if (this.completion.hasCreatedTaskTr) {
          this.stepsData.stepCollabFirstTask.isDone = true;
        }
      } else if (this.userType == 'firstUser') {
        if (this.completion.isVerified) {
          this.stepsData.stepFirstUserValidEmail.isDone = true;
        }
        if (this.completion.hasInvited) {
          this.stepsData.stepFirstUserInvit.isDone = true;
        }
        if (this.completion.hasCreatedProject) {
          this.stepsData.stepFirstUserProject.isDone = true;
        }
        if (this.completion.hasViewedReport) {
          this.stepsData.stepFirstUserReport.isDone = true;
        }

      }
    },

    /*
      D'après les infos en cookie, met à jour this.stepsData pour marquer les steps comme ignorés.
      Permet de "persister" le choix d'un utilisateur d'ignorer un step à travers différentes session
     */
    updateIgnoredSteps() {

      // on lit le contenu du cookie, chaque step trouvé dedans est marqué comme à ignorer dans this.stepsData
      let ignored = JSON.parse(this.$cookie.get('ignoredGettingStarted'))
      if (this.userType == 'collaborator') {
        if (_.includes(ignored, 'stepCollabValidEmail')) {
          this.stepsData.stepCollabValidEmail.isIgnored = true;
        }
        if (_.includes(ignored, 'stepCollabInstallPwa')) {
          this.stepsData.stepCollabInstallPwa.isIgnored = true;
        }
        if (_.includes(ignored, 'stepCollabFirstTask')) {
          this.stepsData.stepCollabFirstTask.isIgnored = true;
        }
      } else if (this.userType == 'firstUser') {
        if (_.includes(ignored, 'stepFirstUserValidEmail')) {
          this.stepsData.stepFirstUserValidEmail.isIgnored = true;
        }
        if (_.includes(ignored, 'stepFirstUserInvit')) {
          this.stepsData.stepFirstUserInvit.isIgnored = true;
        }
        if (_.includes(ignored, 'stepFirstUserProject')) {
          this.stepsData.stepFirstUserProject.isIgnored = true;
        }
        if (_.includes(ignored, 'stepFirstUserReport')) {
          this.stepsData.stepFirstUserReport.isIgnored = true;
        }
      }


    }

  },


  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {
    this.defineUserTypeDatas()

    this.getGettingStartedInfos()

    // On écoute la création de task pour mettre à jour le composant si besoin
    this.$root.$on('new_task_started', () => {
      this.getGettingStartedInfos()
    })


  }
}
</script>

